import dayjs from 'dayjs';
import { formatDate } from 'utils/constants/functions';

export interface ICalculateRewardForTeam {
  teamSalesId: string;
  fromMonth: number;
  toMonth: number;
  fromYear: number;
  toYear: number;
}

export interface ICalculateRewardForPlant {
  plantId: string[];
  fromMonth: number;
  toMonth: number;
  fromYear: number;
  toYear: number;
}

export interface IUpdateHotRewardAmount {
  rewardId: string;
  hotRewardAmount: number;
  rewardLastMonth: number;
  note: string;
}

export const RewardCalculationVariables = {
  getRewardCalculation: (params: any) => {
    const {
      page,
      page_size,
      userId,
      plantId,
      toDate,
      fromDate,
      jobTitleCode,
      groupId,
    } = params;
    // console.log('d', toDate.toString());
    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input: {
        ...(userId && { userId }),
        ...(plantId && { plantId }),
        ...(fromDate && {
          fromMonth: Number(dayjs(fromDate).startOf('month').format('MM')),
          fromYear: Number(dayjs(fromDate).startOf('month').format('YYYY')),
        }),
        ...(toDate && {
          toMonth: Number(dayjs(toDate).endOf('month').format('MM')),
          toYear: Number(dayjs(toDate).endOf('month').format('YYYY')),
        }),
        ...(jobTitleCode && { jobTitleCode }),
        ...(groupId && { groupId }),
      },
    };
  },

  rewardCalculation: (params: any) => {
    // userId: '39',
    //   fromDate: '2024-12-01',
    //   toDate: '2024-12-31',
    const { userId, fromDate, toDate } = params;
    return {
      input: {
        ...(userId && { userId }),
        ...(fromDate && {
          fromDate: formatDate(
            dayjs(fromDate).startOf('month').toDate(),
            'YYYY-MM-DD',
          ),
        }),

        ...(toDate && {
          toDate: formatDate(
            dayjs(toDate).endOf('month').toDate(),
            'YYYY-MM-DD',
          ),
        }),
      },
    };
  },

  saveRewardCalculation: (params: any) => {
    const { input } = params;
    return {
      input,
    };
  },
  // calculate Reward For TeamSale
  calculateRewardForTeam: (input: ICalculateRewardForTeam) => {
    return {
      input,
    };
  },
  // calculate Reward For Plant
  calculateRewardForPlant: (input: ICalculateRewardForPlant) => {
    return {
      input,
    };
  },
  updateHotRewardAmount: (input: IUpdateHotRewardAmount) => {
    return {
      input,
    };
  },
};
